import { render, staticRenderFns } from "./WhySectionCard.vue?vue&type=template&id=383d33e2&scoped=true&"
import script from "./WhySectionCard.vue?vue&type=script&lang=js&"
export * from "./WhySectionCard.vue?vue&type=script&lang=js&"
import style0 from "./WhySectionCard.vue?vue&type=style&index=0&id=383d33e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d33e2",
  null
  
)

export default component.exports